import { Close, Save } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab';
import { Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, MenuItem, Select } from '@mui/material';
import ArgonBox from 'components/ArgonBox';
import ArgonButton from 'components/ArgonButton'
import ArgonInput from 'components/ArgonInput';
import ArgonTypography from 'components/ArgonTypography';
import { postSubmit } from 'global/postFunc';
import React, { useEffect, useState } from 'react'

const Tambah = ({
    open,
    handleClose,
    decryptedUser,
    updating,
    setUpdating,
    addReq,
    editData
}) => {

    const [saving, setSaving] = useState(false)

    const [role, setRole] = useState('')
    const [nip, setNip] = useState('')
    const [nama, setNama] = useState('')
    const [jabatan, setJabatan] = useState('')
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [prevUsername, setPrevUsername] = useState('')

    const [submitUrl, setSubmitUrl] = useState('')

    useEffect(() => {
        if (open) {
            if (editData === null) { // Insert
                setRole('')
                setNip('')
                setNama('');
                setJabatan('')
                setUsername('')
                setPassword('')

                setPrevUsername('')
            }
            else { // Edit
                setRole(editData.role)
                setNip(editData.user.nip)
                setNama(editData.user.nama);
                setJabatan(editData.user.jabatan)
                setUsername(editData.username)
                setPassword(editData.password)
    
                setPrevUsername(editData.username)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    const submit = (e) => {
        const formData = {
            role: role,
            nip: nip,
            nama: nama,
            jabatan: jabatan,
            username: username,
            password: password
        }
        
        if (editData === null) {
            setSubmitUrl('/sa/users/admin-insert')
        }
        else{
            formData._method = 'PUT';
            formData.prevUsername = prevUsername;
            setSubmitUrl('/sa/users/admin-update')
        }
        
        addReq()
        e.preventDefault();
        setSaving(true)
        postSubmit(
            submitUrl,
            formData,
            decryptedUser,
            (res) => {
                setSaving(false)
                handleClose()
                setUpdating(!updating)
            },
            (res) => {
                setSaving(false)
                handleClose()
            }
        )
    }

    return (
        <>
            <Dialog
                open={open}
                maxWidth="md"
                fullWidth
                // scroll='paper'
                p={3}
                component='form'
                onSubmit={submit}
            >
                <DialogTitle>
                    <ArgonTypography variant='body2' fontWeight="bold">Tambah Admin</ArgonTypography>
                </DialogTitle>
                <DialogContent p={3}>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Level
                            </ArgonTypography>
                        </ArgonBox>
                        <FormControl fullWidth>
                            <Select
                                placeholder="Select year"
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                disabled={editData !== null}
                                value={role}
                                onChange={(e) => {
                                    setRole(e.target.value)
                                }}
                                required
                            >
                                <MenuItem value='super_admin'>Super Admin</MenuItem>
                                <MenuItem value='admin_pimpinan'>Pimpinan</MenuItem>
                                <MenuItem value='admin_pembangunan'>Admin Pembangunan</MenuItem>
                            </Select>
                        </FormControl>
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Nip
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="text"
                            size="medium"
                            value={nip}
                            onChange={(e) => setNip(e.target.value)}
                            autoComplete='off'
                        />
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Nama
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="text"
                            required
                            size="medium"
                            value={nama}
                            onChange={(e) => setNama(e.target.value)}
                            autoComplete='off'
                        />
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Jabatan
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="text"
                            required
                            size="medium"
                            value={jabatan}
                            onChange={(e) => setJabatan(e.target.value)}
                            autoComplete='off'
                        />
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Username
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="text"
                            required
                            size="medium"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            autoComplete='off'
                        />
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Password
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="text"
                            required
                            size="medium"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete='off'
                        />
                    </ArgonBox>
                </DialogContent>
                <DialogActions>
                    <Grid container spacing={2} justifyContent='flex-end' px={2} mb={2}>
                        <Grid item>
                            <ArgonButton color='info' variant='outlined' size="small" startIcon={<Close />} onClick={handleClose}>Batal</ArgonButton>
                        </Grid>
                        <Grid item>
                            <LoadingButton color='info' variant='contained' size="small" startIcon={<Save />} type='submit' loading={saving}>Simpan</LoadingButton>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default Tambah